import type { ApiResponse, PaginatedData, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import type {
	ListPositionsParams,
	Position,
	PositionCreateRequest,
	PositionUpdateRequest,
} from "../types";

export const positionsService = {
	async list(params: ListPositionsParams): Promise<PaginatedData<Position>> {
		const response = await apiClient.get<ApiResponse<PaginatedData<Position>>>("/positions", {
			params,
		});
		return (response.data as SuccessResponse<PaginatedData<Position>>).data;
	},

	async getById(id: string): Promise<Position> {
		const response = await apiClient.get<SuccessResponse<Position>>(`/positions/${id}`);
		return response.data.data;
	},

	async create(data: PositionCreateRequest): Promise<Position> {
		const response = await apiClient.post<SuccessResponse<Position>>("/positions", data);
		return response.data.data;
	},

	async update(id: string, data: PositionUpdateRequest): Promise<Position> {
		const response = await apiClient.patch<SuccessResponse<Position>>(`/positions/${id}`, data);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/positions/${id}`);
	},
};
